<div class="password-strength-indicator" *transloco="let t">
  <ng-container [ngSwitch]="strength$ | async">
    <span class="empty password-strength-indicator-element" *ngSwitchCase="PasswordStrength.EMPTY"><span>{{ t("PASSWORD.EMPTY") }}</span></span>
    <span class="weak password-strength-indicator-element" *ngSwitchCase="PasswordStrength.WEAK"><span>{{ t("PASSWORD.WEAK") }}</span></span>
    <span class="ok password-strength-indicator-element" *ngSwitchCase="PasswordStrength.OK"><span>{{ t("PASSWORD.OK") }}</span></span>
    <span class="strong password-strength-indicator-element" *ngSwitchCase="PasswordStrength.STRONG"><span>{{ t("PASSWORD.STRONG") }}</span></span>
  </ng-container>
</div>
